import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './confirm-dialog.component.html',
  styles: [
    `
      .dialog-container {
        padding: 24px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      }

      .dialog-header {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 16px;
      }

      .dialog-content {
        font-size: 16px;
        margin-bottom: 24px;
      }

      .dialog-actions {
        display: flex;
        justify-content: flex-end;
      }

      .dialog-actions button {
        margin-left: 8px;
      }
      .close-button {
        position: absolute;
        top: 14px;
        right: 14px;
      }
    `,
  ],
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  /** Seconds left before the confirm button can be used (0 = usable). */
  remaining = 0;
  private timer?: ReturnType<typeof setInterval>;

  readonly dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
  readonly data = inject<{
    title: string;
    message: string;
    confirmButtonText: string;
    /**
     * Optional: keep the confirm button disabled for this many seconds, so a
     * destructive action can't be confirmed in haste. Omitted = no wait.
     */
    confirmDelaySeconds?: number;
  }>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.remaining = Math.max(0, Math.floor(this.data?.confirmDelaySeconds ?? 0));
    if (this.remaining > 0) {
      this.timer = setInterval(() => {
        this.remaining--;
        if (this.remaining <= 0) {
          this.stopTimer();
        }
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.remaining > 0) {
      return;
    }
    this.dialogRef.close(true);
  }

  private stopTimer(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  }
}
